export const CWITNESSCARDMODAL_BODY_OVERFLOW_HIDDEN = 'hidden';
export const CWITNESSCARDMODAL_EASE_CURVE: [number, number, number, number] = [
  0.4,
  0,
  0.2,
  1,
];
